import { useNavigate } from 'react-router-dom'
import { Button } from './ui/button'

export const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="flex-1 min-h-screen flex items-start justify-center bg-[var(--header)] pt-20">
      <div className="text-center px-6 py-8 max-w-lg">
        <h1 className="text-6xl font-bold text-[var(--primary)] mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-[var(--foreground)] mb-4">
          Page Not Found
        </h2>
        <p className="text-[var(--color-grey-600)] mb-8">
          This could be because the web address was misspelled, the external link was incorrect, or there's a problem with our website. If you think it's a problem with our website, please contact us.
        </p>
        <Button
          onClick={() => navigate('/')}
          variant="primary"
          size="lg"
        >
          Go to Home
        </Button>
      </div>
    </div>
  )
}